import type { KinerjaRoleType } from 'types/kinerja'

export const ROLES_LABEL: Record<KinerjaRoleType, string> = {
  GURU_GPK: 'Guru Pendidikan Khusus',
  KS_DEFINITIF: 'Kepala Sekolah',
  KS_PLT: 'Plt. Kepala Sekolah',
  GURU: 'Guru',
  GURU_SPNF: 'Pamong',
  KS_DEFINITIF_SPNF: 'Kepala SKB',
  KS_PLT_SPNF: 'Plt. Kepala SKB',
}
